import BaseAPI from './base.api.service'

const resource = 'expensereports';
export default {
    async get(erID) {
        return await BaseAPI.get(`${resource}/${erID}`);
    },
    async save(request) {
        return await BaseAPI.put(`${resource}/`, request)
    }
} 